module.exports = __webpack_public_path__ + "img/2016.68c05e84.svg";